import React from 'react';
import { NextPage } from 'next';

import loadNamespaces from 'next-translate/loadNamespaces';
import { DistributionLandingLayoutPage } from '../../components/Distribution/DistributionLandingLayoutPage';
import { VirpPageContext } from '../_app';

const MusicDistribution: NextPage = () => <DistributionLandingLayoutPage />;

MusicDistribution.getInitialProps = async (ctx: VirpPageContext) => {
  const getTranslations = await loadNamespaces({
    ...ctx,
    pathname: '/music-distribution',
  });
  return { ...getTranslations };
};

export default MusicDistribution;
